/**
 * Contains the overrides for `Intl.DisplayNames.prototype.of`
 */
export const ofOverrides = {
    ar: {
        region: {
            EU: "بلدان أخرى في أوروبا",
        },
    },
    cs: {
        region: {
            CZ: "Česká republika",
            // Note: If you modify the value on the next line, update the README documentation using the same value
            EU: "Evropa - jiné",
        },
    },
    da: {
        region: {
            EU: "Øvrige Europa",
        },
    },
    de: {
        region: {
            EU: "Übriges Europa",
        },
    },
    el: {
        region: {
            EU: "Λοιπή Ευρώπη",
        },
    },
    en: {
        region: {
            EN: "Other Europe",
            TR: "Türkiye",
        },
    },
    es: {
        region: {
            EU: "Resto de Europa",
        },
    },
    "es-Latn-MX": {
        region: {
            EU: "Otro en Europa",
        },
    },
    fi: {
        region: {
            EU: "Muu Eurooppa",
        },
    },
    fr: {
        region: {
            EU: "Autres Europe",
        },
    },
    he: {
        region: {
            EU: "שאר אירופה",
        },
    },
    hr: {
        region: {
            EU: "Ostatak Europe",
        },
    },
    hu: {
        region: {
            EU: "Európa - egyéb",
        },
    },
    is: {
        language: {
            is: "íslenska",
        },
        region: {
            EU: "Annað í Evrópu",
            IS: "Ísland",
        },
    },
    it: {
        region: {
            EU: "Resto d'Europa",
        },
    },
    ja: {
        region: {
            EU: "欧州（その他）",
        },
    },
    ko: {
        region: {
            EU: "기타 유럽",
        },
    },
    nl: {
        region: {
            EU: "Overige Europa",
        },
    },
    no: {
        region: {
            EU: "Annet i Europa",
        },
    },
    pl: {
        region: {
            EU: "Inne Europa",
        },
    },
    pt: {
        region: {
            EU: "Resto da Europa",
        },
    },
    ro: {
        region: {
            EU: "Alte țări Europa",
        },
    },
    sl: {
        region: {
            EU: "Druge države Evrope",
        },
    },
    sv: {
        region: {
            EU: "Övriga Europa",
        },
    },
    th: {
        language: {
            th: "ภาษาไทย",
        },
        region: {
            EU: "ยุโรปอื่น ๆ",
            TH: "ประเทศไทย",
        },
    },
    tr: {
        region: {
            EU: "Diğer Avrupa",
            TR: "Türkiye",
        },
    },
    zh: {
        region: {
            EU: "欧洲其他国家/地区",
        },
    },
    "zh-Hant": {
        region: {
            EU: "歐洲其他國家/地區",
        },
    },
};
